module.exports = __webpack_public_path__ + "static/media/wear.4fea8f79.png";